import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
const Controls: React.FC<Props> = ({ children }) => {
  return <div>{children}</div>;
};
export default Controls;
